'use client';

import {
  CapturePaypalPayment,
  CreatePaypalOrder,
} from '@/app/lib/initiate-payments';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import { useRouter } from '@/i18n/routing';
import { usePathname } from '@/i18n/routing';

export default function PaypalButtons({ orderAmount, pending, setPending }) {
  const router = useRouter();
  const pathName = usePathname();

  const Client_id = process.env.NEXT_PUBLIC_PAYPAL_CLIENT;

  //For Creating the Paypal Order
  async function createOrder() {
    setPending(true);
    const order = await CreatePaypalOrder(orderAmount);
    setPending(false);
    return order.id;
  }

  //On Payment Approval
  async function onApprove(payment) {
    const orderStatus = await CapturePaypalPayment(payment.orderID);

    if (orderStatus.status === 'COMPLETED') {
      router.push(
        `/payment-success?transactionId=${orderStatus.id}&transactionStatus=${orderStatus.status}`
      );
    }
    return orderStatus;
  }

  return (
    <>
      <PayPalScriptProvider
        options={{
          'client-id': Client_id,
          'currency': 'USD',
          'components': 'buttons',
        }}
      >
        <PayPalButtons
          forceReRender={[orderAmount]}
          fundingSource={'paypal'}
          disabled={pending}
          style={{ width: 100 }}
          className="flex-1 w-1/2 mx-auto"
          createOrder={createOrder}
          onApprove={onApprove}
          onError={(err) => {
            console.log(err);
            alert('Unable to create order!');
          }}
          onCancel={() => {
            alert('Payment is Canceled by User!');
          }}
        />
      </PayPalScriptProvider>
    </>
  );
}
